import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_BqYys5CFH2UomSYNX2XKR25GNVsV5Hiqt2CmPRgu7ZY5';
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';

let initialized = false;

export const initAnalytics = () => {
  if (initialized || !POSTHOG_KEY) return;
  
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
  });
  
  initialized = true;
};

export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId, properties);
};

export const trackEvent = (event: string, properties?: Record<string, any>) => {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, properties);
};

export const resetAnalytics = () => {
  if (!POSTHOG_KEY) return;
  posthog.reset();
};
